import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/remixicon.css';
import './assets/css/style.css';
import './index.css';
import App from './App';
import './i18n'; // Import i18n configuration

// Tell Font Awesome to skip adding the CSS automatically since it's already imported above
config.autoAddCss = false;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<div>Carregando...</div>}>
      <App />
    </Suspense>
  </React.StrictMode>
);
